// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { LASFormat } from "./las-format.js";
// __VERSION__ is injected by babel-plugin-version-inline
// @ts-ignore TS2304: Cannot find name '__VERSION__'.
const VERSION = typeof "4.4.2" !== 'undefined' ? "4.4.2" : 'latest';
/**
 * Loader for the LAS (LASer) point cloud format
 */
export const LASWorkerLoader = {
    ...LASFormat,
    dataType: null,
    batchType: null,
    version: VERSION,
    worker: true,
    options: {
        las: {
            shape: 'mesh',
            fp64: false,
            skip: 1,
            colorDepth: 8
        }
    }
};
//# sourceMappingURL=las-loader.js.map